// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.28/static/css/" + "main" + "." + "3b6d0d49" + ".css";
};